import { createRequest, RequestConfig } from 'app/common/api';

const config: RequestConfig = {
  method: 'get',
  url: '/ws/api/get_user',
};

export const getUserRequest = (id: number) =>
  createRequest({
    url: config.url,
    query: { id: String(id) },
    method: config.method,
  });
